//==================================================================
// Created by Lou Mauget, December/22/2017
// ImageUtil.js
// Utility methods for image caching
//==================================================================
import util from 'util/Util.js';
import RestService        from 'RestService';

const MAX_URLS = 10;

//==================================================================================================================
// See https://stackoverflow.com/questions/6150289/how-to-convert-image-into-base64-string-using-javascript
// Approach 2: canvas --
//
// The toDataURL method returns a data URL that is a base64-constant encoded version of an image returned by a captcha
// service. The caller would presumably set this URL into a captcha view model so that the control's view would show
// a constant rendition throughout an edit session. See PF-2477.
//
// Note that the getter implementation could either return a captcha service URL or a constat URL. We currently
// return a random constant URL because of CORS issues between development envioroments and captcha servers.
//==================================================================================================================
class ImageUtil {

    toDataURL(outputFormat = 'image/jpeg') {
        const srcImageURL = this.captchaURL;

        return new Promise((resolve, reject) => {

            const img = new Image();

            img.crossOrigin = 'Anonymous';
            img.onload = function() {
                const
                    canvas = document.createElement('CANVAS'),
                    ctx = canvas.getContext('2d');

                canvas.height = this.naturalHeight;
                canvas.width = this.naturalWidth;
                ctx.drawImage(this, 0, 0);

                const dataURL = canvas.toDataURL(outputFormat);
                resolve(dataURL);
            };

            img.src = srcImageURL;

            // Ensure the load event fires for cached images too.
            // Conditionally Flush cache and retry ...
            if (img.complete || img.complete === undefined) {
                // Flush cache
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                // Retry
                img.src = srcImageURL;
            }
        });
    }

    //==================================================================================================
    // This getter implementation chooose a random canned captchar image used in the editor only.
    // To use a captcha service URL instead, change the body to return that URL. The base URL
    // would likely be the same domain htat serves this Yoda app or else it must allow
    // cross-domain access.
    //==================================================================================================
    get captchaURL() {
        return require(`captcha/default_captcha${Math.floor(Math.random() * MAX_URLS)}.jpg`);
    }

    //==================================================================================================
    // PF-3935
    // Method that retrieves a captcha image from the presentation server depending on the query parameters sent to it, which are related to the background and text color.
    // The last parameter tells the server to not refresh the captcha image on an associated control, which also required some changes from the server side code implemented by Antonio.
    //==================================================================================================
    getCaptchaPresentationServerURLByView(view){
        return `${RestService.hostUrl}/PresentationServer/CaptchaHandler.ashx?id=${view.model.get('id')}&style=${util.extractNum(view.model.get('width'))}-${util.extractNum(view.model.get('height'))}-${view.model.get('length')}-${util.remove("#", view.model.get('backgroundColor')) }-${util.remove("#", view.model.get('styleColorText'))}&instanceGUID=afe959e3facb48ad85bc696930ef0a&random=3&keepText=${view.model.get('keepText')}`;
    }
}

const imageUtil = new ImageUtil();
export default imageUtil;
